'use strict';

var React = require('react');
var Border = require('../common/Border');
var util = require('../../helper/util');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

/**
 * 便签条
 */
var StickyNote = React.createClass({

  render: function () {
    var isShowTabBar = this.props.isShowTabBar;
    var text = styleHelper.getText(this.props);
    var textArray = util.Text.delimitToParagraphs(text);
    var backgroundStyle;
    var tabBarStyle;
    var textStyle;
    var tabBarHeight = isShowTabBar ? 22 : 0;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var fontSize = styleHelper.getFontSize(this.props);
    var lineHeight =  styleHelper.builderLineHeight(this.props);
    if (isShowTabBar) {
      tabBarStyle = {
        position: 'absolute',
        left: Math.round((w - w * (71 / 178)) / 2),
        top: 0,
        width: Math.round(w * (71 / 178)),
        height: tabBarHeight,
        backgroundColor: '#e33c2f'
      };
    }

    backgroundStyle = {
      top: tabBarHeight / 2,
      borderStyle: 'none',
      height: h - tabBarHeight / 2,
      width: '100%',
      left: 0,
      position: 'absolute',
      backgroundColor: styleHelper.getBackgroundColor(this.props)
    };


    textStyle = {
      left: 12,
      top: 10 + tabBarHeight / 2,
      width: w - 2 * 12,
      height: backgroundStyle.height - 16 - tabBarHeight / 2,
      position: 'absolute',
      overflow: 'hidden',
      lineHeight : lineHeight + 'px'
    };

    styleHelper.StyleUtil(this.props,textStyle).text().align();
    return (<div>
      <div style={backgroundStyle}>
        <div style={textStyle}>
          {
            textArray.map(function(t, idx){
              t = util.Text.replaceIndentSpace(util.Text.convertSpaceToNbsp(t));
              return (<p key={idx}>{t}</p>);
            })
          }
        </div>
      </div>
      <div style={tabBarStyle}/>
    </div>);

  }
});

module.exports = StickyNote;




/** WEBPACK FOOTER **
 ** ./src/views/Components/StickyNote.jsx
 **/